// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./firebase/AuthContext";
import "@fontsource-variable/inter/opsz.css";
import "@fontsource-variable/figtree";
import "./index.css";
import "./theme.css";
import PublicSite from "./pages/PublicSite";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

function PrivateRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="loading">Loading...</div>;
  return user ? children : <Navigate to="/admin/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<PrivateRoute><AdminDashboard /></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
